/* MATLEON — carrito para preguntar por varios productos en un solo WhatsApp (no hay pago en línea).
   Usa el carrito real de Shopify (/cart/add.js, /cart/change.js, /cart.js): se guarda solo entre visitas y Shopify
   registra los "agregados al carrito". API: window.MTCarrito.agregar(idVariante, cantidad) · abrir() · cerrar(). */
(function () {
  var dlg = document.querySelector('[data-mt-carro]');
  if (!dlg) return;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (s, r) { return (r || dlg).querySelector(s); };
  var lista = $('[data-mt-carro-lista]'), vacio = $('[data-mt-carro-vacio]'), pie = $('[data-mt-carro-pie]');
  var totalEl = $('[data-mt-carro-total]'), cuentaEl = $('[data-mt-carro-cuenta]'), waEl = $('[data-mt-carro-wa]');
  var aviso = $('[data-mt-carro-aviso]');
  var D = dlg.dataset;
  var carrito = null;
  try { carrito = JSON.parse(document.getElementById('mt-carro-datos').textContent); } catch (e) {}

  // ---------- utilidades ----------
  function dinero(centavos) {
    var n = (Number(centavos) || 0) / 100;
    // MATLEON: precio limpio ($16,399): sin centavos si son .00 y sin espacio tras el signo
    var sin = Math.round(n).toLocaleString('en-US');
    var con = n % 1 ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : sin;
    return (D.formato || '$ {{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sin)
      .replace(/\{\{\s*amount\s*\}\}/, con)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, con)
      .replace(/^(\D+?)\s+(?=\d)/, '$1');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function foto(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function tallaDe(it) {
    if (it.product_has_only_default_variant || !it.options_with_values) return '';
    return it.options_with_values.map(function (o) { return /talla|size/i.test(o.name) ? 'Talla ' + o.value : o.value; }).join(' · ');
  }
  function pedir(url, datos) {
    return fetch(url, {
      method: datos ? 'POST' : 'GET',
      headers: datos ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: datos ? JSON.stringify(datos) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; });
    });
  }

  // ---------- mensaje de WhatsApp con todos los productos ----------
  function enlaceWhatsApp(c) {
    var formatoTalla = D.textoTalla || 'Talla: {talla}';
    var lineas = c.items.map(function (it, i) {
      var talla = (!it.product_has_only_default_variant && it.options_with_values)
        ? it.options_with_values.map(function (o) { return /talla|size/i.test(o.name) ? formatoTalla.replace(/\{talla\}/g, o.value) : o.name + ': ' + o.value; }).join(' · ')
        : '';
      var datos = [talla, it.quantity > 1 ? 'Cantidad: ' + it.quantity : '', dinero(it.final_line_price)].filter(Boolean).join(' · ');
      return (i + 1) + '. ' + it.product_title + '\n' + datos + '\n' + (D.origen || location.origin) + it.url;
    });
    var msg = (D.mensaje || '{productos}')
      .replace(/\{productos\}/g, lineas.join('\n\n'))
      .replace(/\{total\}/g, dinero(c.total_price))
      .replace(/\{cantidad\}/g, c.item_count);
    // cliente con sesión: nombre y correo para saber quién es
    var cli = window.mtCliente;
    if (cli) msg += '\n\nMi cuenta MATLEON: ' + (cli.nombre || '') + (cli.correo ? ' (' + cli.correo + ')' : '');
    return 'https://wa.me/' + (D.numero || '') + '?text=' + encodeURIComponent(msg);
  }

  // ---------- pintar ----------
  function pintar(c, nuevaClave) {
    carrito = c;
    var hay = c && c.item_count > 0;
    vacio.hidden = hay; pie.hidden = !hay;
    cuentaEl.textContent = hay ? '(' + c.item_count + ')' : '';
    lista.innerHTML = !hay ? '' : c.items.map(function (it) {
      var talla = tallaDe(it);
      return '<li class="mt-carro__item' + (it.key === nuevaClave ? ' mt-carro__item--nuevo' : '') + '" data-clave="' + esc(it.key) + '">' +
        '<a class="mt-carro__foto" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
          (it.image ? '<img src="' + esc(foto(it.image, 240)) + '" srcset="' + esc(foto(it.image, 240)) + ' 1x, ' + esc(foto(it.image, 480)) + ' 2x" alt="" width="120" height="150" decoding="async">' : '') +
        '</a>' +
        '<div class="mt-carro__info">' +
          (it.vendor ? '<p class="mt-carro__marca">' + esc(it.vendor) + '</p>' : '') +
          '<a class="mt-carro__nombre" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (talla ? '<p class="mt-carro__talla">' + esc(talla) + '</p>' : '') +
          '<div class="mt-carro__fila">' +
            '<div class="mt-carro__cant" role="group" aria-label="Cantidad de ' + esc(it.product_title) + '">' +
              botonMenos(it.quantity) +
              '<span aria-live="polite" data-cant>' + it.quantity + '</span>' +
              '<button type="button" data-paso="1" aria-label="Uno más"><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8M6 2v8" stroke="currentColor" stroke-width="1.4"/></svg></button>' +
            '</div>' +
            '<p class="mt-carro__precio" data-linea>' + dinero(it.final_line_price) + '</p>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('');
    resumen(c);
  }

  // El botón de "menos": con 1 pieza es el botecito de basura (quitar)
  function botonMenos(q) {
    return '<button type="button" data-paso="-1" aria-label="' + (q > 1 ? 'Uno menos' : 'Quitar del carrito') + '">' + (q > 1
      ? '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 6h8" stroke="currentColor" stroke-width="1.4"/></svg>'
      : '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 3h8M4.5 3V1.5h3V3M3 3l.6 7.5h4.8L9 3" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>') + '</button>';
  }

  // Totales, mensaje de WhatsApp y burbuja del icono (sin volver a dibujar la lista)
  function resumen(c) {
    var hay = c && c.item_count > 0;
    vacio.hidden = hay; pie.hidden = !hay;
    cuentaEl.textContent = hay ? '(' + c.item_count + ')' : '';
    if (hay) { totalEl.textContent = dinero(c.total_price); waEl.href = enlaceWhatsApp(c); }
    // Contador del icono de la cabecera
    document.querySelectorAll('[data-mt-carro-icono]').forEach(function (ic) {
      var b = ic.querySelector('[data-mt-carro-burbuja]');
      if (!b) return;
      b.textContent = c && c.item_count > 0 ? (c.item_count > 99 ? '99+' : c.item_count) : '';
      b.hidden = !(c && c.item_count > 0);
      ic.setAttribute('aria-label', 'Carrito' + (c && c.item_count ? ', ' + c.item_count + (c.item_count === 1 ? ' producto' : ' productos') : ', vacío'));
    });
  }

  // Huella del carrito: si al abrirlo Shopify devuelve lo mismo que ya se ve, NO se vuelve a dibujar la lista.
  // Antes se redibujaba a media animación de entrada y en celular (respuesta más lenta) los renglones parpadeaban y
  // volvían a entrar.
  function huella(c) { return c ? c.item_count + '|' + c.total_price + '|' + c.items.map(function (it) { return it.key + ':' + it.quantity + ':' + it.final_line_price; }).join(',') : ''; }
  function refrescar() {
    return pedir('/cart.js').then(function (c) {
      if (carrito && huella(c) === huella(carrito)) { carrito = c; resumen(c); } else pintar(c);
      return c;
    });
  }

  // ---------- abrir / cerrar (con movimiento; el cajón entra desde la derecha) ----------
  var cerrando = null;
  // Al abrir, el navegador enfoca la X mientras el cajón aún está fuera de la pantalla y "recorre" el diálogo
  // para mostrarla (salto brusco). El CSS lo impide con overflow: clip; esto cubre a los Safari viejos.
  dlg.addEventListener('scroll', function () { if (dlg.scrollTop || dlg.scrollLeft) { dlg.scrollTop = 0; dlg.scrollLeft = 0; } });
  function abrir() {
    if (cerrando) { clearTimeout(cerrando); cerrando = null; }
    if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
    document.documentElement.classList.add('mt-carro-activo');
    // Los renglones entran en cascada SOLO al abrir (no cada vez que cambia una cantidad o se quita algo)
    var yaAbierto = dlg.classList.contains('mt-carro--abierto');
    if (!yaAbierto) {
      dlg.classList.add('mt-carro--entrando');
      clearTimeout(abrir.t); abrir.t = setTimeout(function () { dlg.classList.remove('mt-carro--entrando'); }, 900);
    }
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('mt-carro--abierto'); }); });
  }
  function cerrar() {
    if (!dlg.open) return;
    dlg.classList.remove('mt-carro--abierto');
    document.documentElement.classList.remove('mt-carro-activo');
    cerrando = setTimeout(function () { cerrando = null; if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }, reducido.matches ? 160 : 380);
  }
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); cerrar(); });
  dlg.addEventListener('click', function (e) {
    if (e.target.closest('[data-mt-carro-cerrar]')) { cerrar(); return; }
    var b = e.target.closest('[data-paso]');
    if (b) { cambiar(b.closest('[data-clave]'), Number(b.dataset.paso)); return; }
    if (e.target.closest('[data-mt-carro-vaciar]')) {
      pedir('/cart/clear.js', {}).then(pintar);
    }
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mt-carro-abrir]');
    if (!a) return;
    e.preventDefault();
    abrir();
    refrescar();
  });

  // Cambiar cantidad: el número, el precio del renglón y el total cambian AL INSTANTE (sin bloquear el botón ni volver
  // a dibujar el carrito); a Shopify se le manda solo la cantidad final, 350 ms después del último toque. Antes cada
  // toque esperaba la respuesta y redibujaba todo (con su animación): por eso se sentía trabado.
  var pendientes = {}; // clave → { q, timer }
  function cambiar(li, paso) {
    if (!li || !carrito) return;
    var clave = li.dataset.clave;
    var it = carrito.items.find(function (x) { return x.key === clave; });
    if (!it) return;
    var p = pendientes[clave] || (pendientes[clave] = { q: it.quantity, timer: null });
    p.q = Math.max(0, p.q + paso);
    if (p.q === 0) { quitar(li, clave); return; }
    // Al instante, en pantalla
    var copia = JSON.parse(JSON.stringify(carrito)), ic = copia.items.find(function (x) { return x.key === clave; });
    copia.item_count += p.q - ic.quantity;
    copia.total_price += (p.q - ic.quantity) * ic.final_price;
    ic.quantity = p.q; ic.final_line_price = p.q * ic.final_price;
    li.querySelector('[data-cant]').textContent = p.q;
    li.querySelector('[data-linea]').textContent = dinero(ic.final_line_price);
    var menos = li.querySelector('[data-paso="-1"]');
    if (menos && (p.q === 1) !== (menos.getAttribute('aria-label') === 'Quitar del carrito')) menos.outerHTML = botonMenos(p.q);
    carrito = copia;
    resumen(copia);
    // A Shopify, una sola vez
    clearTimeout(p.timer);
    p.timer = setTimeout(function () {
      var q = p.q;
      pedir('/cart/change.js', { id: clave, quantity: q }).then(function (c) {
        if (pendientes[clave] === p && p.q === q) delete pendientes[clave];
        if (pendientes[clave]) return; // hubo más toques mientras tanto: manda la siguiente vuelta
        var real = c.items.find(function (x) { return x.key === clave; });
        // Si Shopify no dejó esa cantidad, se muestra la real (aquí sí se redibuja)
        if (!real || real.quantity !== q) { pintar(c); return; }
        carrito = c; resumen(c);
      }).catch(function () { delete pendientes[clave]; refrescar(); });
    }, 350);
  }

  // Quitar: el renglón se encoge mientras Shopify lo borra
  function quitar(li, clave) {
    var p = pendientes[clave]; if (p) clearTimeout(p.timer); delete pendientes[clave];
    li.style.pointerEvents = 'none';
    var hecho = pedir('/cart/change.js', { id: clave, quantity: 0 });
    var fin = Promise.resolve();
    if (!reducido.matches && li.animate) {
      var alto = li.offsetHeight;
      fin = li.animate([{ opacity: 1, height: alto + 'px' }, { opacity: 0, height: '0px', paddingTop: '0px', paddingBottom: '0px' }], { duration: 280, easing: 'cubic-bezier(0.23, 1, 0.32, 1)', fill: 'forwards' }).finished;
    }
    Promise.all([hecho, fin]).then(function (r) { pintar(r[0]); aviso.textContent = 'Producto quitado del carrito'; }).catch(function () { refrescar(); });
  }

  // ---------- agregar (lo llama la ficha) ----------
  function agregar(id, cantidad) {
    return pedir('/cart/add.js', { items: [{ id: Number(id), quantity: cantidad || 1 }] }).then(function (r) {
      var clave = r.items && r.items[0] && r.items[0].key;
      return pedir('/cart.js').then(function (c) {
        pintar(c, clave);
        aviso.textContent = 'Agregado al carrito';
        // La burbuja del icono da un saltito para que se note que algo entró
        document.querySelectorAll('[data-mt-carro-burbuja]').forEach(function (b) {
          if (b.animate && !reducido.matches) b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' });
        });
        abrir();
        return c;
      });
    });
  }

  window.MTCarrito = { agregar: agregar, abrir: abrir, cerrar: cerrar, refrescar: refrescar };
  if (carrito) pintar(carrito);
  // Al volver con "atrás" la página puede salir de la memoria con un carrito viejo
  window.addEventListener('pageshow', function (e) { if (e.persisted) refrescar(); });
})();
